import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
// import { NavController } from '@ionic/angular';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-catalogue-card',
  templateUrl: './catalogue-card.component.html',
  styleUrls: ['./catalogue-card.component.scss'],
})
export class CatalogueCardComponent implements OnInit {
  @Input() catalogue: any = undefined;
  @Input() loop: any = undefined;
  public type = '';
  public customStyle = undefined;

  constructor(
    private navCtrl: NavController,
    private paramSv: ParamServicesService
  ) {}

  ngOnInit() {
    if (this.paramSv.typeCatalogue) {
      this.setTypes();
    } else {
      const paramObs = this.paramSv.emitImagesObs.subscribe((item: any) => {
        if (item.name === 'catalogueStyle') {
          this.setTypes();
        } else if (item === 'finish') {
          paramObs.unsubscribe();
        }
      });
    }
  }

  setTypes() {
    this.type = this.paramSv.typeCatalogue?.type;
    this.customStyle = this.paramSv.typeCatalogue?.customStyle;
  }

  goCatalogue(id) {
    console.log('id :>> ', id);
    this.navCtrl.navigateForward(`catalogue/${id}`);
  }
}
